import styled from 'styled-components'

export const VideoPlayerWrapper = styled.div`
    display:flex;
    justify-content:center;
    width:100%;
    height:100vh;
    background: rgba(0, 0, 0, 0.6);
    
    
`